export const renderNotificationStackRoutes = ({}) => {
    return null;
};
